import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool } from "prop-types";
import { push } from "connected-react-router";

import { selectors as investmentfundsSelectors } from "reducers/investmentfunds";

import Col from "react-bootstrap/lib/Col";
import PageLoading from "pages/_components/PageLoading";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import MainContainer from "pages/_components/MainContainer";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import I18n from "pages/_components/I18n";

class NoProfileInfo extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
    };

    render() {
        const { fetching, dispatch } = this.props;
        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                <CustomProductHead titleId="investmentFunds.investorTest.profile.title" className="new-deposit-request">
                    <div className="toolbar-item view-title">
                        <ViewTitle id="investmentFunds.investorTest.profile.title" />
                    </div>
                </CustomProductHead>
                <MainContainer className="main-container">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <div className="illustration text-center">
                                <Image src="images/figma/illustrations/advertisement.svg" className="svg-image logo" />
                                <div className="pb-6" />
                                <Col xs={12} md={10} mdOffset={1}>
                                    <div className="font-bold">
                                        <I18n id="investmentFunds.investorTest.noProfile.info" />
                                    </div>
                                </Col>
                            </div>
                        </Row>
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4}>
                                <div className="toolbar-item add-button" key="add">
                                    <CustomButton
                                        func={() => dispatch(push("/investmentFunds/accounts/add"))}
                                        className="btn btn-primary btn-block"
                                        icon="images/figma/icon/nuevo.svg"
                                        text="investmentFunds.myAccounts.requestAccount"
                                        textType="I18N"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </PageLoading>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
});
export default connect(mapStateToProps)(NoProfileInfo);
